
import { variablesGlobales } from '../../configs/variables';
import getInstanceAxios from '../axiosInstance';

export class LastActivityService {

    static async getLastActivityPaginate(data={}) {
        try {
            let axiosInstance = getInstanceAxios();
            const responseServer = await axiosInstance.post(`${variablesGlobales.urlServiceBackend}/api/v1/lastActivity/getActivityPaginate`, data);
            const jsonData = await responseServer.data;
            return {
                error: false,
                message: jsonData,
                date: new Date()
            };

        } catch (error) {
            return {
                error: true,
                message: error.response?.data ?? error.message,
                date: new Date(),
                code: error.code,
                status: 500
            }
        }
    }
}